import { hasMinimumRole } from '@/constants';
import { hasAllPermissions } from '@/utils/accountPermissions';

/**
 * Filter sidebar / nav definitions by optional minimum app role and required permission flags.
 * Items omitting both `requiredRole` and `requiredPermissions` are shown when `user` is present.
 *
 * @param {{ role: string, permissions?: number } | null | undefined} user
 * @param {Array<{ requiredRole?: string, requiredPermissions?: (string|number)[] } & Record<string, unknown>>} items
 */
export function filterNavItems(user, items) {
    if (!user) return [];
    const mask = user.permissions ?? 0;
    return items.filter((item) => {
        if (item.requiredRole != null && !hasMinimumRole(user.role, item.requiredRole)) {
            return false;
        }
        const req = item.requiredPermissions;
        if (req?.length) {
            return hasAllPermissions(mask, ...req);
        }
        return true;
    });
}
